import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form } from "formik";
import { EmployeeCreateSchema } from "../../../Schemas/employee/employee_creaate_schema";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import performRequest from "../../../api/request";
import { EmployeeInfoCreate } from "../../../SchemaInfo/info";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman } from "react-icons/fc";
import { BsArrowRightShort } from "react-icons/bs";
import { useSelector } from "react-redux";
import { toTitleCase } from "../../../Components/Functions/word.fun";

const AddEmployee = () => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [reportingTo, setReportingTo] = useState([]);
  const handelSubmit = (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });
    values = {
      ...values,
      firstName: toTitleCase(values.firstName),
      position: toTitleCase(values.position),
      lastName: toTitleCase(values.lastName),
      city: toTitleCase(values.city),
    };
    setLoading(true);
    performRequest(
      "POST",
      "/employeeManagement/createEmployeeManagement1stStep",
      values
    )
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Employee Added to Database!");
          navigate(`/employee-management`);
        } else if (res.data?.error === "User already exists") {
          Toast("error", "User already exists");
        } else {
          Toast("error", "Error while uploading data");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setReportingTo(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcBusinessman className="fs-2  me-1" /> Employee management
                </h2>
                <h4 className="text-muted">
                  <p>Add new employee to organization.</p>
                </h4>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 mb-1">
                <h3 className="m-0 p-0">Organization Details:</h3>
                <hr className="m-1" />
                <div className="p-1">
                  <p className="p-0 m-0 fw-bold">Kryzen Biotech Pvt Ltd</p>
                  <p className="p-0 mb-2 fw-bold">
                    #98, At. Post Degaon, Wai, Satara, Maharashtra, India 412803
                  </p>
                  <p className="p-0 m-0">GST: 27AAHCK7659R1ZF</p>
                  <p className="p-0 m-0">PAN:AAHCK7659R</p>
                  <p className="p-0 m-0">CIN: U01100PN2019PTC186207</p>
                  <hr className="p-0 my-2" />
                  <p className="p-0 m-0">Total Staff:22</p>
                  <p className="p-0 m-0">Active Position: 2</p>
                  <p className="p-0 m-0">On Probation:20</p>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={EmployeeInfoCreate}
                  validationSchema={EmployeeCreateSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <h2 className="m-0 p-2">Fill all Employee Details</h2>
                      <hr className="my-1" />
                      <div className="row px-4">
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              First name
                            </label>
                            <div className="w-100">
                              {" "}
                              <CustomInput name="firstName" type="text" />
                              {props.touched.firstName &&
                                props.errors.firstName && (
                                  <p className="text-danger">
                                    {props.errors.firstName}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Last name
                            </label>
                            <div className="w-100">
                              {" "}
                              <CustomInput name="lastName" type="text" />
                              {props.touched.lastName &&
                                props.errors.lastName && (
                                  <p className="text-danger">
                                    {props.errors.lastName}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Gender
                            </label>
                            <div className="w-100">
                              <CustomSelect type="text" name="gender">
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="prefer not to mention">
                                  Prefer not to mention
                                </option>
                              </CustomSelect>
                              {props.touched.gender && props.errors.gender && (
                                <p className="text-danger">
                                  {props.errors.gender}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Contact number
                            </label>
                            <div className="w-100">
                              {" "}
                              <CustomInput name="contactNumber" type="text" />
                              {props.touched.contactNumber &&
                                props.errors.contactNumber && (
                                  <p className="text-danger">
                                    {props.errors.contactNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Aadhar card number
                            </label>
                            <div className="w-100">
                              {" "}
                              <CustomInput
                                name="aadharcardNumber"
                                type="text"
                              />
                              {props.touched.aadharcardNumber &&
                                props.errors.aadharcardNumber && (
                                  <p className="text-danger">
                                    {props.errors.aadharcardNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Pan card number
                            </label>
                            <div className="w-100">
                              {" "}
                              <CustomInput name="pancardNumber" type="text" />
                              {props.touched.pancardNumber &&
                                props.errors.pancardNumber && (
                                  <p className="text-danger">
                                    {props.errors.pancardNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Permanant address
                            </label>
                            <div className="w-100">
                              {" "}
                              <CustomInput
                                name="permanantAddress"
                                type="text"
                              />
                              {props.touched.permanantAddress &&
                                props.errors.permanantAddress && (
                                  <p className="text-danger">
                                    {props.errors.permanantAddress}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Residential address
                            </label>
                            <div className="w-100">
                              {" "}
                              <CustomInput
                                name="residentialAddress"
                                type="text"
                              />
                              {props.touched.residentialAddress &&
                                props.errors.residentialAddress && (
                                  <p className="text-danger">
                                    {props.errors.residentialAddress}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Date of joining
                            </label>
                            <div className="w-100">
                              <CustomInput type="date" name="dateOfJoining" />
                              {props.touched.dateOfJoining &&
                                props.errors.dateOfJoining && (
                                  <p className="text-danger">
                                    {props.errors.dateOfJoining}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Role in organization
                            </label>

                            <div className="w-100">
                              <CustomSelect
                                type="text"
                                name="roleInOrganisation"
                              >
                                <option value="">Select Role</option>
                                <option value="superAdmin">Super Admin</option>

                                <option value="adminStaff">Admin Staff</option>
                                <option value="purchaseStaff">
                                  Purchase Staff
                                </option>
                                <option value="saleStaff">Sales Staff</option>
                                <option value="agronomistStaff">
                                  Agronomist Staff
                                </option>
                                <option value="opsStaff">Ops Staff</option>
                                <option value="inspectionStaff">
                                  Inspection Staff
                                </option>
                                <option value="marketingStaff">
                                  Marketing Staff
                                </option>
                                <option value="labourStaff">
                                  Labour Staff
                                </option>
                                <option value="accountStaff">
                                  Account Staff
                                </option>
                                <option value="ITStaff">IT Staff</option>
                                <option value="SMMStaff">SMM Staff</option>
                                <option value="salesManager">
                                  Sales Manager
                                </option>
                                <option value="clientFeedback">
                                  Client Feedback
                                </option>
                                <option value="HR">Human Resources</option>
                                <option value="Jr.HR">
                                  Jr. Human Resources
                                </option>
                                <option value="salesCoordinator">
                                  Sales Coordinator
                                </option>
                                <option value="officeStaff">
                                  Office Staff
                                </option>
                                <option value="marketingAgency">
                                Marketing Agency
                                </option>
                              </CustomSelect>
                              {props.touched.roleInOrganisation &&
                                props.errors.roleInOrganisation && (
                                  <p className="text-danger">
                                    {props.errors.roleInOrganisation}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Package joined at
                            </label>
                            <div className="w-100">
                              <CustomInput type="text" name="packageJoinedAt" />
                              {props.touched.packageJoinedAt &&
                                props.errors.packageJoinedAt && (
                                  <p className="text-danger">
                                    {props.errors.packageJoinedAt}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div> */}
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Position
                            </label>
                            <div className="w-100">
                              <CustomInput type="text" name="position" />
                              {props.touched.position &&
                                props.errors.position && (
                                  <p className="text-danger">
                                    {props.errors.position}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">City</label>
                            <div className="w-100">
                              <CustomInput type="text" name="city" />
                              {props.touched.city && props.errors.city && (
                                <p className="text-danger">
                                  {props.errors.city}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Interview Date
                            </label>
                            <div className="w-100">
                              <CustomInput type="date" name="interviewDate" />
                              {props.touched.interviewDate &&
                                props.errors.interviewDate && (
                                  <p className="text-danger">
                                    {props.errors.interviewDate}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label required">
                              Employee Personal Email Id
                            </label>
                            <div className="w-100">
                              <CustomInput type="text" name="personalEmail" />
                              {props.touched.personalEmail &&
                                props.errors.personalEmail && (
                                  <p className="text-danger">
                                    {props.errors.personalEmail}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12 my-1">
                          <div className="row">
                            <label className="form-label ">
                              Free Lancer Staff
                            </label>

                            <div className="w-100">
                              <CustomSelect type="text" name="isfreeLancer">
                                <option value="">Select</option>
                                <option value="freeLancerStaff">
                                  Free Lancer Staff
                                </option>
                              </CustomSelect>
                              {props.touched.isfreeLancer &&
                                props.errors.isfreeLancer && (
                                  <p className="text-danger">
                                    {props.errors.isfreeLancer}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer mt-4">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Create Employee" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AddEmployee;
